export default "__VITE_ASSET__CXmby0Jb__"